import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import signupBg from "../../../../assets/signup_bg.jpg";
import { getLoginInfo } from "../../../../Redux/Reducer/LoginReducer";
import "./Login.css";


export default function Login() {
  const {register,handleSubmit,formState: { errors },} = useForm();
	let navigate = useNavigate()
  const dispatch = useDispatch()
  const { loginInfo, er} = useSelector((state) => state.loginInfo);

  const onSubmit = (data) => {
    console.log(data);
    dispatch(getLoginInfo(data))
  };

 
  useEffect(() => {
		
		if (loginInfo.status == 200) {
			
			toast.success("Login Successfull", {
				position: "top-right",
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
			})
      setTimeout(() => {
        navigate("/")
        window.location.reload() 
      }, 1500);
		 
		}
 
		 

	}, [loginInfo])

  return (
    <>
      <section className="relative self-center">
        <div className="relative z-10 p-8">
          <form
            className="max-w-lg mx-auto bg-gray-50 rounded-lg shadow-lg py-10 px-8  space-y-4"
            onSubmit={handleSubmit(onSubmit)}
          >
            <h3 className="text-gray-800 font-semibold text-center text-xl">
              Login To Your Account
            </h3>
            <div className="space-y-2">
              {/* phone */}
              <div className="form-group cmb-10">
                <label className="pure-material-textfield-outlined">
                  <input
                    type="text"
                    placeholder=" "
                    {...register("email", { required: true })}
                  />
                
                  <span className="text-gray-700 font-medium">
                    Email or Phone Number
                  </span>
                </label>
              </div>

              {errors.email && errors.email.type === "required" && (
                <span className="text-xs py-2 font-semibold text-red-600 text-left">
                  Email or Phone number is required
                </span>
              )}
              {/* password */}
              <div className="form-group cmb-10">
                <label className="pure-material-textfield-outlined">
                  <input
                    type="password"
                    placeholder=" "
                    {...register("password", { required: true })}
                  />
                  <span className="text-gray-700 font-medium">Password</span>
                </label>
              </div>
              {errors.password && errors.password.type === "required" && (
                <span className="text-xs py-2 font-semibold text-red-600 text-left">
                  Password is required
                </span>
              )}
            </div>

            <div className="flex flex-col justify-center space-y-6">
              <div className="space-y-2">
                <input
                  className="bg-gradient-to-r from-[#2995FC]  to-[#3076CE] py-2 px-6 rounded-lg text-white text-base w-full cursor-pointer"
                  type="submit"
                  value="Login"
                />
                <Link
                  to="/forget-password"
                  className="text-sm font-normal text-[#0073FA] cursor-pointer"
                >
                  Forgot password?
                </Link>
              </div>

             
            </div>
          </form>
        </div>

        {/* signup background */}
        <figure className="absolute inset-0 z-0">
          <img
            className="h-auto w-full object-contain sm:object-cover rounded-lg"
            src={signupBg}
            alt="product"
          />
        </figure>
        <ToastContainer/>
      </section>
    </>
  );
}
